import type { DashWidgetTypes } from 'src/components/Dashboards/dash-types';

export type WidgetTypeDebugMeta = {
	label: string;
	color: string;
};

export const WIDGET_TYPE_DEBUG: Record<DashWidgetTypes, WidgetTypeDebugMeta> = {
	dashInfo: { label: 'Info', color: '#22d3ee' },
	dashGroup: { label: 'Group', color: '#a78bfa' },
	dashControlDev: { label: 'Control device', color: '#f97316' },
	dashParameterDev: { label: 'Parameter device', color: '#eab308' },
	dashQuickDev: { label: 'Quick device', color: '#34d399' },
	dashCardDev: { label: 'Card device (legacy)', color: '#3b82f6' },
	dashCamera: { label: 'Camera', color: '#ec4899' },
	dashRoom: { label: 'Room', color: '#14b8a6' },
	dashScene: { label: 'Scene', color: '#8b5cf6' },
	dashAlarm: { label: 'Alarm', color: '#ef4444' },
	dashWeather: { label: 'Weather', color: '#38bdf8' },
	dashChart: { label: 'Chart', color: '#f59e0b' },
	dashMedia: { label: 'Media', color: '#6366f1' },
	dashLight: { label: 'Light', color: '#facc15' },
	dashThermostat: { label: 'Thermostat', color: '#fb7185' },
	dashEnergyInfo: { label: 'Energy info', color: '#4ade80' },
	dashEnergyKpiLive: { label: 'Energy KPI live', color: '#86efac' },
	dashEnergyKpiPeriod: { label: 'Energy KPI period', color: '#bbf7d0' },
	dashEnergyTopConsumers: { label: 'Top consumers', color: '#65a30d' },
	dashEnergyConsumerMix: { label: 'Consumer mix', color: '#a3e635' },
	dashEnergyRoomChart: { label: 'Energy room chart', color: '#0d9488' },
	dashEnergyFlow: { label: 'Energy flow', color: '#2dd4bf' },
	dashEnergyHeatmap: { label: 'Energy heatmap', color: '#f43f5e' },
	dashEnergyPeak: { label: 'Energy peak', color: '#fb923c' },
	dashEnergyInsights: { label: 'Energy insights', color: '#c084fc' },
	dashEnergyGeneration: { label: 'Energy generation', color: '#84cc16' },
	dashEnergyPvDistribution: { label: 'PV distribution', color: '#d9f99d' },
	dashEnergyTariff: { label: 'Energy tariff', color: '#fbbf24' },
	dashEnergyPhase: { label: 'Energy phase', color: '#7dd3fc' },
	dashEnergyEnvironmental: { label: 'Energy environmental', color: '#5eead4' },
	dashEnergyDeviceTrend: { label: 'Energy device trend', color: '#818cf8' },
	dashEnergyRoomCharts: { label: 'Energy room charts', color: '#67e8f9' },
	dashEnergyRoomDistribution: { label: 'Room distribution', color: '#99f6e4' },
	dashEnvironment: { label: 'Environment', color: '#6ee7b7' },
};

export const WIDGET_TYPE_DEBUG_FALLBACK: WidgetTypeDebugMeta = {
	label: 'Unknown',
	color: '#94a3b8',
};

export const getWidgetTypeDebug = (type?: string): WidgetTypeDebugMeta => {
	if (type && type in WIDGET_TYPE_DEBUG) {
		return WIDGET_TYPE_DEBUG[type as DashWidgetTypes];
	}

	return WIDGET_TYPE_DEBUG_FALLBACK;
};

export const WIDGET_TYPE_DEBUG_ENTRIES = Object.entries(WIDGET_TYPE_DEBUG) as [
	DashWidgetTypes,
	WidgetTypeDebugMeta,
][];
